export enum PositionLevelState {
  NONE,
  WARNING,
  ALERT,
}

export namespace PositionLevelState {
  let elements = [PositionLevelState.NONE, PositionLevelState.WARNING, PositionLevelState.ALERT];
  let alias = "com.bcdfx.model.PositionLevelState";

  export function RemoteClass() {
    return alias;
  }

  export function getAllElements() {
    return elements;
  }
}
